import MuiTooltip, { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';
import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';

import { teceoGrayPrimary } from '../Theme';

type BackgroundColor = 'primary' | 'error';

interface TooltipStyleParams {
  backgroundColor?: BackgroundColor;
  maxWidth?: number | string;
  padding?: number;
}

export const useTooltipStyles = makeStyles<TooltipStyleParams>()(
  (theme, { backgroundColor, maxWidth, padding }) => ({
    tooltip: {
      backgroundColor: backgroundColor === 'error' ? theme.palette.error.main : teceoGrayPrimary,
      fontSize: 13,
      fontWeight: 600,
      color: 'white',
      boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
      maxWidth: maxWidth || 500,
      borderRadius: 12,
      padding: padding ?? theme.spacing(1.5),
    },
    arrow: {
      color: backgroundColor === 'error' ? theme.palette.error.main : teceoGrayPrimary,
      boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
    },
  }),
);

type TooltipProps = MuiTooltipProps & {
  backgroundColor?: BackgroundColor;
  maxWidth?: number | string;
  padding?: number;
  enterTouchDelay?: number;
};

const Tooltip = ({
  backgroundColor = 'primary',
  maxWidth,
  padding,
  enterTouchDelay,
  ...props
}: TooltipProps) => {
  const { classes } = useTooltipStyles({ backgroundColor, maxWidth, padding });
  return <MuiTooltip classes={classes} {...props} enterTouchDelay={enterTouchDelay ?? 0} />;
};

export default memo(Tooltip);
